import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';
import { UserService } from '../../../../../app/shared/API-Service/services/user.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';



@Component({
  selector: 'app-view-user',
  templateUrl: './view-user.component.html',
  styleUrls: ['./view-user.component.css']
})
export class ViewUserComponent implements OnInit {
  users:object [] = [];
  constructor(private _UserService:UserService,private _Router:Router) { }

  ngOnInit(): void {
    this.getusers();
  }
  getusers(){
    this._UserService.GetUser().subscribe((res) => {
      this.users = res.data 
    },(err)=>{
      console.log('their is a problem');
    },() =>{
      console.log('Completed');
    });
  }

  // update(data){
  //   this._UserService.Data.next(data);
  //   this._Router.navigate(['/content/admin/InsertUser']);
  //   }
    // delete(id : number){
    //   Swal.fire({
    //     title: 'Are you sure?',
    //     text: "You won't be able to revert this!",
    //     icon: 'warning',
    //     showCancelButton: true,
    //     confirmButtonColor: '#3085d6',
    //     cancelButtonColor: '#d33',
    //     confirmButtonText: 'Yes, delete it!'
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       this._UserService.DeleteUser(id).subscribe((res) => {
    //         Swal.fire({
    //           icon: "success",
    //           title: "Deleted Successfuly",
    //           showConfirmButton: false,
    //           timer: 1500,
    //         });
    //      this.getusers();
    //       },(err) => {
    //         Swal.fire({
    //           icon: 'error',
    //           title: 'Error',
    //           text:err.error.message    
    //         })
    //       },() => {
    //         console.log("completed");
    //       })
    //     }
    //   }) 
    // }
}
